<!--
  Layout A, pages: each step is a page of its own with a back link (library → set → compare, or
  → Edit set). The library stays mounted while hidden, so its filters and search survive a visit
  to a set.
-->
<template>
  <div class="md-pages">
    <MediaLibrary v-show="nav.view === 'library'" v-on="nav.on.library" />
    <MediaSetView v-if="nav.isViewer" :context="nav.viewerContext" :back-label="nav.backLabel" v-on="nav.on.viewer" />
    <MediaCompare v-else-if="nav.view === 'compare'" :ids="nav.pair" :back-label="nav.backLabel" v-on="nav.on.compare" />
    <MediaSetEditor v-else-if="nav.view === 'edit' && nav.setId" :set-id="nav.setId" :back-label="nav.backLabel" v-on="nav.on.editor" />
    <MediaCaptureFlow v-else-if="nav.view === 'capture'" :as-note="nav.asNote" :patient-uid="store.patientUid" back-label="Back to Media" v-on="nav.on.capture" />
  </div>
</template>

<script setup>
import { useMediaStore } from '@/stores/mediaStore';
import MediaLibrary from './MediaLibrary.vue';
import MediaSetView from './MediaSetView.vue';
import MediaCompare from './MediaCompare.vue';
import MediaSetEditor from './MediaSetEditor.vue';
import MediaCaptureFlow from './MediaCaptureFlow.vue';

defineProps({ nav: { type: Object, required: true } });
const store = useMediaStore();
</script>
